import React from 'react';
import { connect } from 'react-redux';
import FloatingCreateButton from 'components/FloatingCreateButton';
import {
  newModule,
  showDiscardNewModuleConfirmationDialog,
} from 'manage-modules/redux/manageModulesActions';

const AddModuleButton = ({ isNew, onAdd, onCancel }) =>
  <FloatingCreateButton
    isCancel={isNew}
    onCreate={onAdd}
    onCancel={onCancel}
  />;

const mapStateToProps = state => {
  const { module } = state.manageModules.moduleCard;
  return {
    isNew: !module.id,
  };
};

const mapDispatchToProps = dispatch => ({
  onAdd: () => dispatch(newModule()),
  onCancel: () => dispatch(showDiscardNewModuleConfirmationDialog()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddModuleButton);
